<template>
  <div>
    <!-- Header -->
    <section class="content-generalCtx">
      <div
        class="ranking-header"
        :data-number="getPositionVar('RGO-02-TOTAL FRP INTRALABORALES')"
      >
        <img
          src="@/assets/icons/seal-duotone.svg"
          alt="ranking icon"
          width="120"
        />
        <span
          v-tooltip.right="'Posición actual frente al total de empresas'"
          class="tag"
          >Posición Empresa</span
        >
      </div>
      <div class="hero hero-context">
        <div class="hero-body has-text-centered" style="align-content: center;">
          <div class="container">
            <nav class="level">
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Empresas</p>
                  <p class="title">
                    {{ generalContext.headers.clients || 0 }}
                  </p>
                </div>
              </div>
              <!-- <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Líderes</p>
                  <p class="title">
                    {{ generalContext.headers.leaders || 0 }}
                  </p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Encuestados</p>
                  <p class="title">
                    {{ generalContext.headers.data || 0 }}
                  </p>
                </div>
              </div> -->
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Años</p>
                  <p class="title">
                    {{ generalContext.headers.min || "--" }} -
                    {{ generalContext.headers.max || "--" }}
                  </p>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </section>

    <!-- Second Part Header of Quadrants -->
    <div class="box">
      <div class="columns has-text-centered">
        <div class="column is-two-fifths">
          <span class="heading has-text-weight-bold"
            >Prioridad de intervención</span
          >
          <div class="column">
            <table class="is-flex is-fullwidth" id="table-1">
              <tr
                class="bg-alta"
                v-tooltip.bottom-start="{
                  content: `<span class='has-text-centered' style='width: 100%'>Si Riesgo Alto y Riesgo muy alto es mayor o igual a 30%</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Alta
              </tr>
              <tr
                class="bg-media"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'>Si Riesgo Alto y Riesgo muy alto es menor a 30%, pero Riesgo alto, muy alto y medio es mayor o igual a 40%</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Media
              </tr>
              <tr
                class="bg-destacado"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'>Si sin riesgo o riesgo bajo es mayor o igual a 60%</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Destacado
              </tr>
            </table>
          </div>
        </div>
        <div style="width: 10% !important; margin: auto !important">
          <div class="ranking ranking-only-icon">
            <img
              src="@/assets/icons/ranking-linear.svg"
              alt="rankingIconCL7"
              width="60"
            />
            <!-- <div class="info">
              <span class="subtitle-ranking">
                Entre
                <strong>0</strong>
                Empresa
              </span>
            </div> -->
          </div>
        </div>
        <div class="column">
          <span class="heading has-text-weight-bold">Niveles de benchmark</span>
          <div class="column">
            <p>
              Distribución de empresas según % de colaboradores en riesgo bajo y
              sin riesgo o riesgo despreciable
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Third Part Quadrants -->
    <div class="box" v-if="this.generalContext.data">
      <!-- Principales -->
      <div v-for="(v, k) in groups" :key="k + 'graphsP'">
        <!-- Data Normal -->
        <div class="columns has-text-centered">
          <!-- Column Title -->
          <div class="column is-two-fifths">
            <div>
              <div
                class="heading is-size-6 border"
                :class="rangoIntervencion(frsm['dataAdmin'][v.first])"
                style="padding-top: 5px; margin-top: 15px;"
              >
                <div class="columns">
                  <!-- Icon -->
                  <div class="column is-2">
                    <i
                      class="material-icons has-text-white icon-dash"
                      v-tooltip.top="'Ver más'"
                      v-on:click="showSubGroups(k)"
                      style="cursor: pointer;"
                    >
                      {{
                        v.active
                          ? "remove_circle_outline"
                          : "add_circle_outline"
                      }}
                    </i>
                  </div>
                  <!-- Text -->
                  <div class="column titleC">
                    {{
                      interpretations[v.first]
                        ? interpretations[v.first].title
                        : "Error en los datos."
                    }}
                  </div>
                  <div
                    v-tooltip.top="{
                      content: createBodyTooltipInter(v),
                      classes: 'contentTooltipInter',
                    }"
                    class="column is-2"
                    v-on:click="
                      getDataInter(frsm['dataAdmin'][v.first], v.title)
                    "
                  >
                    <i
                      class="material-icons has-text-white icon-dash"
                      style="cursor: pointer;"
                    >
                      info
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Ranking -->
          <div class="ranking">
            <div
              class="info"
              style="width: 100%;"
              v-tooltip.bottom="
                'Esta es tu posición actual en base al total de empresas'
              "
            >
              <span class="title-ranking card-position">
                {{ getPositionVar(v.first) }}
              </span>
            </div>
          </div>
          <!-- Columns Graph -->
          <div class="column">
            <div style="padding-top: 0.6% !important; margin: 0px !important;">
              <GraphChartJs
                :config="createdLineContext(v.first)"
                :cambio="cambio"
              />
            </div>
          </div>
        </div>

        <article v-if="v.sub && !v.sub2 && v.active" class="message">
          <div class="message-body">
            <div v-for="(vS, kS) in v.sub" :key="kS + 'sub1'">
              <!-- Data Normal -->
              <div class="columns has-text-centered">
                <!-- Column Title -->
                <div class="column is-two-fifths">
                  <div>
                    <div
                      class="heading is-size-6 border"
                      :class="rangoIntervencion(frsm['dataAdmin'][vS.first])"
                      style="padding-top: 5px; margin-top: 15px;"
                    >
                      <div class="columns">
                        <div class="column is-2"></div>
                        <!-- Text -->
                        <div class="column titleC">
                          {{
                            interpretations[vS.first]
                              ? interpretations[vS.first].title
                              : "Error en los datos."
                          }}
                        </div>
                        <div
                          v-tooltip.top="{
                            content: createBodyTooltipInter(vS),
                            classes: 'contentTooltipInter',
                          }"
                          class="column is-2"
                          v-on:click="
                            getDataInter(frsm['dataAdmin'][vS.first], vS.title)
                          "
                        >
                          <i
                            class="material-icons has-text-white icon-dash"
                            style="cursor: pointer;"
                          >
                            info
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Ranking -->
                <div class="ranking">
                  <div
                    class="info"
                    style="width: 100%;"
                    v-tooltip.bottom="
                      'Esta es tu posición actual en base al total de empresas'
                    "
                  >
                    <span class="title-ranking card-position">
                      {{ getPositionVar(vS.first) }}
                    </span>
                  </div>
                </div>
                <!-- Columns Graph -->
                <div class="column">
                  <div
                    style="padding-top: 0.6% !important; margin: 0px !important;"
                  >
                    <GraphChartJs
                      :config="createdLineContext(vS.first)"
                      :cambio="cambio"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        <article v-if="v.sub2 && v.active" class="message">
          <div class="message-body">
            <div v-for="(vS, kS) in v.sub2" :key="kS + 'sub2'">
              <!-- Data Normal -->
              <div class="columns has-text-centered">
                <!-- Column Title -->
                <div class="column is-two-fifths">
                  <div>
                    <div
                      class="heading is-size-6 border"
                      :class="rangoIntervencion(frsm['dataAdmin'][vS.first])"
                      style="padding-top: 5px; margin-top: 15px;"
                    >
                      <div class="columns">
                        <!-- Icon -->
                        <div class="column is-2">
                          <i
                            v-tooltip="'Ver más'"
                            class="material-icons has-text-white icon-dash"
                            v-on:click="showSubGroups(k, kS)"
                            style="cursor: pointer;"
                          >
                            {{
                              vS.active
                                ? "remove_circle_outline"
                                : "add_circle_outline"
                            }}
                          </i>
                        </div>
                        <!-- Text -->
                        <div class="column titleC">
                          {{
                            interpretations[vS.first]
                              ? interpretations[vS.first].title
                              : "Error en los datos."
                          }}
                        </div>
                        <div
                          v-tooltip.top="{
                            content: createBodyTooltipInter(vS),
                            classes: 'contentTooltipInter',
                          }"
                          class="column is-2"
                          v-on:click="
                            getDataInter(frsm['dataAdmin'][vS.first], vS.title)
                          "
                        >
                          <i
                            class="material-icons has-text-white icon-dash"
                            style="cursor: pointer;"
                          >
                            info
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Ranking -->
                <div class="ranking">
                  <div
                    class="info"
                    style="width: 100%;"
                    v-tooltip.bottom="
                      'Esta es tu posición actual en base al total de empresas'
                    "
                  >
                    <span class="title-ranking card-position">
                      {{ getPositionVar(vS.first) }}
                    </span>
                  </div>
                </div>
                <!-- Columns Graph -->
                <div class="column">
                  <div
                    style="padding-top: 0.6% !important; margin: 0px !important;"
                  >
                    <GraphChartJs
                      :config="createdLineContext(vS.first)"
                      :cambio="cambio"
                    />
                  </div>
                </div>
              </div>
              <article
                v-if="!v.sub && v.sub2 && vS.sub && vS.active"
                class="message"
              >
                <div class="message-body">
                  <div v-for="(vT, kT) in vS.sub" :key="kT + 'sub3'">
                    <!-- Data Normal -->
                    <div class="columns has-text-centered">
                      <!-- Column Title -->
                      <div class="column is-two-fifths">
                        <div>
                          <div
                            class="heading is-size-6 border"
                            :class="
                              rangoIntervencion(frsm['dataAdmin'][vT.first])
                            "
                            style="padding-top: 5px; margin-top: 15px;"
                          >
                            <div class="columns">
                              <div class="column is-2"></div>
                              <!-- Text -->
                              <div class="column titleC">
                                {{ interpretations[vT.first].title }}
                              </div>
                              <div
                                v-tooltip.top="{
                                  content: createBodyTooltipInter(vT),
                                  classes: 'contentTooltipInter',
                                }"
                                class="column is-2"
                              >
                                <i
                                  class="material-icons has-text-white icon-dash"
                                  style="cursor: pointer;"
                                  v-on:click="
                                    getDataInter(
                                      frsm['dataAdmin'][vT.first],
                                      vT.title,
                                    )
                                  "
                                >
                                  info
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Ranking -->
                      <div class="ranking">
                        <div
                          class="info"
                          style="width: 100%;"
                          v-tooltip.bottom="
                            'Esta es tu posición actual en base al total de empresas'
                          "
                        >
                          <span class="title-ranking card-position">
                            {{ getPositionVar(vT.first) }}
                          </span>
                        </div>
                      </div>
                      <!-- Columns Graph -->
                      <div class="column">
                        <div
                          style="padding-top: 0.6% !important; margin: 0px !important;"
                        >
                          <GraphChartJs
                            :config="createdLineContext(vT.first)"
                            :cambio="cambio"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </article>
      </div>
    </div>

    <div class="is-flex is-justify-center" v-if="this.generalContext.data">
      <!-- Title Efectos -->
      <hr class="has-text-dark" style="width: 30%" />
      <h1
        class="title is-size-4 is-flex"
        style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
      >
        Efectos
        <div
          v-tooltip.top="{
            content: createBodyTooltipInter({ first: 'EFECTOS' }),
            classes: 'contentTooltipInter',
          }"
          style="padding-left: 10px;padding-top: 2px;"
        >
          <i class="material-icons has-text-black-bis">
            info_outline
          </i>
        </div>
      </h1>
      <hr class="has-text-dark" style="width: 30%" />
    </div>

    <div class="box" v-if="this.generalContext.data">
      <!-- Efectos -->
      <div v-for="(v, k) in efectos" :key="k + 'graphsE'">
        <div v-if="v.first === 'RGO-09-Engagement'">
          <!-- Part Header of Quadrants - Engagement -->
          <div style="margin-right: 10px; margin-left: 10px;">
            <hr />
          </div>
          <div class="columns has-text-centered">
            <div class="column is-two-fifths">
              <span class="heading has-text-weight-bold"
                >Prioridad de intervención</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-1">
                  <tr
                    class="bg-alta"
                    v-tooltip.bottom-start="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Muy bajo y bajo es mayor o igual a 30%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Alta
                  </tr>
                  <tr
                    class="bg-media"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Muy bajo y bajo es menor a 30%, pero Muy bajo, bajo y medio es mayor o igual a 40%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Media
                  </tr>
                  <tr
                    class="bg-destacado"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Muy alto y alto a 60%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Destacado
                  </tr>
                </table>
              </div>
            </div>
            <div style="width: 10% !important; margin: auto !important">
              <div class="ranking ranking-only-icon">
                <img
                  src="@/assets/icons/ranking-linear.svg"
                  alt="rankingIconCL7"
                  width="60"
                />
              </div>
            </div>
            <div class="column">
              <span class="heading has-text-weight-bold"
                >Niveles de benchmark - Efecto</span
              >
              <div class="column">
                <p>
                  Distribución de empresas según % de colaboradores en niveles
                  altos y muy altos
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Data Normal -->
        <div class="columns has-text-centered">
          <!-- Column Title -->
          <div class="column is-two-fifths">
            <div>
              <div
                class="heading is-size-6 border"
                :class="
                  rangoIntervencion(
                    frsm['dataAdmin'][v.first],
                    v.first === 'RGO-09-Engagement' ? 1 : 0,
                  )
                "
                style="padding-top: 5px; margin-top: 15px;"
              >
                <div class="columns">
                  <!-- Icon -->
                  <div class="column is-2">
                    <i
                      class="material-icons has-text-white icon-dash"
                      v-tooltip.top="'Ver más'"
                      v-on:click="showSubGroups(k)"
                      v-if="v.sub && v.sub.length"
                      style="cursor: pointer;"
                    >
                      {{
                        v.active
                          ? "remove_circle_outline"
                          : "add_circle_outline"
                      }}
                    </i>
                  </div>
                  <!-- Text -->
                  <div class="column titleC">
                    {{ interpretations[v.first].title }}
                  </div>
                  <div
                    v-tooltip.top="{
                      content: createBodyTooltipInter(v),
                      classes: 'contentTooltipInter',
                    }"
                    class="column is-2"
                    v-on:click="
                      getDataInter(frsm['dataAdmin'][v.first], v.title)
                    "
                  >
                    <i
                      class="material-icons has-text-white icon-dash"
                      style="cursor: pointer;"
                    >
                      info
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Ranking -->
          <div class="ranking">
            <div
              class="info"
              style="width: 100%;"
              v-tooltip.bottom="
                'Esta es tu posición actual en base al total de empresas'
              "
            >
              <span class="title-ranking card-position">
                {{ getPositionVar(v.first) }}
              </span>
            </div>
          </div>
          <!-- Columns Graph -->
          <div class="column">
            <div style="padding-top: 0.6% !important; margin: 0px !important;">
              <GraphChartJs
                :config="createdLineContext(v.first)"
                :cambio="cambio"
              />
            </div>
          </div>
        </div>

        <article v-if="v.sub && v.sub.length && v.active" class="message">
          <div class="message-body">
            <div v-for="(vS, kS) in v.sub" :key="kS + 'sub4'">
              <!-- Data Normal -->
              <div class="columns has-text-centered">
                <!-- Column Title -->
                <div class="column is-two-fifths">
                  <div
                    class="heading is-size-6 border"
                    :class="rangoIntervencion(frsm['dataAdmin'][vS.first])"
                    style="padding-top: 5px; margin-top: 15px;"
                  >
                    <div class="columns">
                      <div class="is-2"></div>
                      <!-- Text -->
                      <div class="column titleC">
                        {{ interpretations[vS.first].title }}
                      </div>
                      <div
                        v-tooltip.top="{
                          content: createBodyTooltipInter(vS),
                          classes: 'contentTooltipInter',
                        }"
                        class="column is-2"
                        v-on:click="
                          getDataInter(frsm['dataAdmin'][vS.first], vS.title)
                        "
                      >
                        <i
                          class="material-icons has-text-white icon-dash"
                          style="cursor: pointer;"
                        >
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Ranking -->
                <div class="ranking">
                  <div
                    class="info"
                    style="width: 100%;"
                    v-tooltip.bottom="
                      'Esta es tu posición actual en base al total de empresas'
                    "
                  >
                    <span class="title-ranking card-position">
                      {{ getPositionVar(vS.first) }}
                    </span>
                  </div>
                </div>
                <!-- Columns Graph -->
                <div class="column">
                  <div
                    style="padding-top: 0.6% !important; margin: 0px !important;"
                  >
                    <GraphChartJs
                      :config="createdLineContext(vS.first)"
                      :cambio="cambio"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import GraphChartJs from "../dashboard/GraphChartJs.vue";
import json from "./interpretaciones.json";

export default {
  data: () => {
    return {
      cambio: 1,
      example: {
        type: "line",
        data: {
          datasets: [
            {
              label: "Empresas",
              data: [
                {
                  x: 0,
                  y: 0,
                },
                {
                  x: 5,
                  y: 0,
                },
                {
                  x: 10,
                  y: 0,
                },
                {
                  x: 15,
                  y: 0,
                },
                {
                  x: 20,
                  y: 0,
                },
                {
                  x: 25,
                  y: 1,
                },
                {
                  x: 30,
                  y: 1,
                },
                {
                  x: 35,
                  y: 1,
                },
                {
                  x: 40,
                  y: 3,
                },
                {
                  x: 45,
                  y: 1,
                },
                {
                  x: 50,
                  y: 8,
                },
                {
                  x: 55,
                  y: 2,
                },
                {
                  x: 60,
                  y: 7,
                },
                {
                  x: 65,
                  y: 2,
                },
                {
                  x: 70,
                  y: 4,
                },
                {
                  x: 75,
                  y: 4,
                },
                {
                  x: 80,
                  y: 0,
                },
                {
                  x: 85,
                  y: 1,
                },
                {
                  x: 90,
                  y: 1,
                },
                {
                  x: 95,
                  y: 0,
                },
                {
                  x: 100,
                  y: 0,
                },
              ],
              fill: false,
              color: [
                "#fda0a0",
                "#fda0a0",
                "#fda0a0",
                "#f5bc95",
                "#f5bc95",
                "#f5bc95",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#d9ead3",
                "#d9ead3",
                "#d9ead3",
                "#76be7c",
                "#76be7c",
                "#76be7c",
                null,
              ],
              backgroundColor: [
                "#fda0a0",
                "#fda0a0",
                "#fda0a0",
                "#f5bc95",
                "#f5bc95",
                "#f5bc95",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#fde8af",
                "#d9ead3",
                "#d9ead3",
                "#d9ead3",
                "#76be7c",
                "#76be7c",
                "#76be7c",
                null,
              ],
              borderColor: "rgb(75, 192, 192)",
              tension: 0.2,
            },
          ],
        },
        options: {
          tooltips: {
            callbacks: {},
          },
          legend: {
            display: false,
            position: "right",
          },
          responsive: true,
          maintainAspectRatio: false,
          resizeDelay: 0,
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 1,
                  beginAtZero: true,
                  padding: 0,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                type: "linear",
                ticks: {
                  stepSize: 5,
                  min: 0,
                  max: 100,
                  autoSkip: false,
                  display: false,
                },
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          annotation: {
            annotations: [
              {
                id: "a-line-1",
                type: "line",
                mode: "vertical",
                scaleID: "x-axis-0",
                value: "52.78",
                borderColor: "rgba(0, 0, 0, 0.5)",
                borderWidth: 2,
                labelEnabled: true,
                imagenStatus: false,
                label: {
                  enabled: true,
                  content: ".",
                  position: "top",
                  fontColor: "#FFFFFF",
                  fontSize: 14,
                  fontStyle: "bold",
                  fontFamily: "Arial",
                  backgroundColor: "rgba(0, 0, 0, 0)",
                  xPadding: 10,
                  yPadding: 0,
                  yAdjust: 0,
                  cornerRadius: 5,
                },
              },
            ],
          },
        },
        plugins: [{}],
      },
      generalContext: {
        headers: {
          position: 0,
        },
      },
      interpretations: json,
    };
  },
  props: {
    frsm: Object,
    groups: Object,
    efectos: Object,
    rangoIntervencion: Function,
    showSubGroups: Function,
    createBodyTooltipInter: Function,
    getDataInter: Function,
    validateDataGraph: Function,
    calculatePorcentage: Function,
    rangoFp: Function,
  },
  computed: {
    ...mapState(["tokenUser", "idtoken"]),
  },
  methods: {
    async getContext() {
      try {
        if (
          this.tokenUser &&
          !(this.tokenUser.admin || this.tokenUser.cliente)
        )
          return;
        const result = await apiServices.get("/generalContextFrp");
        if (result.data) {
          this.generalContext.data = result.data.context;
          this.generalContext.headers = result.data.headers;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // Funcion para crear grafica de benchmark
    createdLineContext(group) {
      if (
        !group ||
        !this.generalContext.data ||
        !this.generalContext.data[group]
      )
        return this.example;

      const stepDefault = 10;
      const position = this.calculateRiskContext(
        this.frsm.dataAdmin[group],
        group,
      );

      const context = Object.entries(this.generalContext.data[group]);
      const labels = context.map(([k, v]) => parseInt(k));
      const colors = labels.map((v) => this.getInfoRange(v));

      return {
        type: "line",
        data: {
          datasets: [
            {
              label: "Empresas",
              data: context.map(([k, v]) => {
                return { x: Number(k), y: Number(v) };
              }),
              fill: false,
              color: colors,
              backgroundColor: colors,
              borderColor: "rgb(75, 192, 192)",
              tension: 0.2,
              pointRadius: function(context) {
                const dataIndex = context.dataIndex;
                const dataset = context.dataset.data;

                if (dataIndex === 0 || dataIndex === dataset.length - 1) {
                  return 4;
                }

                const value = dataset[dataIndex].y;
                return value === 0 ? 0 : 4;
              },
            },
          ],
        },
        options: {
          tooltips: {
            mode: "nearest",
            callbacks: {
              title: function(tooltipItem, data) {
                const value = tooltipItem[0].label;
                const nextStep = parseInt(value) + stepDefault;
                if (nextStep > 100) return `${value}%`;
                return `${value}% al ${nextStep}%`;
              },
            },
          },
          legend: { display: false, position: "right" },
          responsive: true,
          maintainAspectRatio: false,
          resizeDelay: 0,
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 5,
                  beginAtZero: true,
                  padding: 0,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                type: "linear",
                ticks: {
                  stepSize: stepDefault,
                  min: Math.min(...labels),
                  max: Math.max(...labels),
                  autoSkip: false,
                  display: false,
                },
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          annotation: {
            annotations: [
              {
                id: "a-line-1",
                type: "line",
                mode: "vertical",
                scaleID: "x-axis-0",
                value: position.toFixed(2),
                borderColor: "rgba(0, 0, 0, 0.5)",
                borderWidth: 2,
                labelEnabled: true,
                imagenStatus: false,
                label: {
                  enabled: true,
                  content: `${position.toFixed(1).replace(".", ",")}%`,
                  position: "top",
                  fontColor: "#522687",
                  fontSize: 11,
                  fontStyle: "bold",
                  fontFamily: "Arial",
                  backgroundColor: "#FFFFFF",
                  xPadding: 8,
                  yPadding: 3,
                  yAdjust: 28,
                  cornerRadius: 999,
                },
              },
            ],
          },
        },
        plugins: [
          {
            beforeDraw: (chart) => {
              const ctx = chart.chart.ctx;

              const xScale = chart.scales["x-axis-0"];
              const yScale = chart.scales["y-axis-0"];

              xScale.ticks.forEach((tick, index) => {
                const tickX = xScale.getPixelForTick(index);
                ctx.fillStyle = this.getInfoRange(tick);
                const tickWidth =
                  index < xScale.ticks.length - 1
                    ? xScale.getPixelForTick(index + 1) - tickX
                    : xScale.right - tickX;

                ctx.fillRect(tickX, yScale.bottom, tickWidth, 20);
              });
            },
            afterDatasetsDraw: (chart) => {
              const ctx = chart.ctx;
              const sizeImg = 30;
              // Recorre las anotaciones y dibuja la imagen
              Object.entries(chart.annotation.elements).forEach(
                ([key, annotation]) => {
                  if (annotation.options.type !== "line") return;

                  const model = annotation._model;

                  if (!model || isNaN(model.x1) || isNaN(model.y1)) return;

                  if (annotation.options.imagenStatus) {
                    ctx.drawImage(
                      annotation.options.img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg,
                    );
                  }

                  // Dibuja una imagen junto al texto de la anotación
                  const img = new Image();
                  img.src = require("@/assets/icons/companyDefault.png");
                  img.onload = () => {
                    annotation.options.img = img;
                    ctx.drawImage(
                      img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg,
                    ); // Dibuja la imagen en el gráfico
                    annotation.options.imagenStatus = true;
                  };
                },
              );
            },
          },
        ],
      };
    },
    getInfoRange(value, type = "color") {
      const ranges = [
        {
          range: [0, 16],
          color: "#f4fbf2",
          title: "%",
        },
        {
          range: [16, 30],
          color: "#dff4d7",
          title: "%",
        },
        { range: [30, 70], color: "#c9ecbd", title: "%" },
        { range: [70, 84], color: "#b4e5a2", title: "%" },
        { range: [84, 101], color: "#9edd88", title: "%" },
      ];
      const rangeObject = ranges.find(({ range }) => value < range[1]);
      return rangeObject ? rangeObject[type] : null;
    },
    calculateRiskContext(data, group) {
      const effects = [
        "RGO-10-Burnout",
        "RGO-10-Agotamiento Emocional",
        "RGO-10-Cinismo",
        "RGO-10-Pérdida de Autoeficacia",
        "RGO-11-Estrés",
      ];

      const validSubgrupos = [
        "Sin riesgo o riesgo despreciable",
        "Riesgo bajo",
        "Riesgo medio",
        "Riesgo alto",
        "Riesgo muy alto",
        "Muy bajo",
        "Bajo",
        "Medio",
        "Alto",
        "Muy alto",
      ];
      const validData = data.filter((item) =>
        validSubgrupos.includes(item.SubGrupo),
      );

      if (!validData.length) return 0;

      const total = validData.reduce(
        (acc, item) => acc + (item.countData.sum || 0),
        0,
      );
      if (total === 0) return 0;

      const sumByGroups = (validGroups) =>
        validData.reduce(
          (acc, item) =>
            acc +
            (validGroups.includes(item.SubGrupo) ? item.countData.sum || 0 : 0),
          0,
        );

      let groupsValid = ["Sin riesgo o riesgo despreciable", "Riesgo bajo"];

      if (group === "RGO-09-Engagement") {
        groupsValid = ["Muy alto", "Alto"];
      } else if (effects.includes(group)) {
        groupsValid = ["Muy bajo", "Bajo"];
      }

      const sumRisk = sumByGroups(groupsValid);

      const round1 = (n) => Math.round(n * 10) / 10;

      return round1((sumRisk / total) * 100);
    },
    getPositionVar(group) {
      if (!this.generalContext.headers || !this.generalContext.headers.ranking)
        return "-";
      if (!this.generalContext.headers.ranking[group]) return "-";

      const value = this.calculateRiskContext(
        this.frsm.dataAdmin[group],
        group,
      );

      if (value === null) return "-";
      const position = this.generalContext.headers.ranking[group].filter(
        (item) => {
          if (item.proceso_id_mongo === this.frsm._id) return false;
          return item.porcentaje > value;
        },
      ).length;

      return position + 1;
    },
  },
  created() {
    if (this.idtoken) {
      this.getContext();
    }
  },
  components: {
    GraphChartJs,
  },
};
</script>
<style lang="scss" scoped>
// Card position
.ranking {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 10% !important;
}

.ranking-only-icon {
  width: 100% !important;
  align-items: center;
  flex-direction: column;
  justify-content: center !important;
  margin: auto 20px auto 0 !important;
}

.ranking .info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ranking .title-ranking {
  color: #363636;
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.ranking .subtitle-ranking {
  line-height: normal;
}

.card-position {
  width: 65px;
  height: 65px;
  color: #4a4a4a;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

// Header
.content-generalCtx {
  position: relative;
  display: flex;
  margin-top: 25px;
  margin-bottom: 25px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    top: -5px;
  }
}

.hero-context {
  border-radius: 10px !important;
  background-color: #d27ff93e !important; // #f3f3f3
  width: 100%;
  @media screen and (max-width: 768px) {
    padding-top: 20px;
    border-top: #510087 solid;
  }
}

.hero-context .hero-body {
  padding: 35px !important;
}

.hero-context .iconCtx {
  border-right: 3px solid #d27ff93e;
  padding-right: 30px;
}

.ranking-header {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  @media screen and (max-width: 768px) {
    bottom: -39px;
    margin-right: 0 !important;
  }
}

.ranking-header .tag {
  position: relative;
  background-color: #510087;
  font-weight: 800;
  color: white;
  top: -12px;
}

.ranking-header::before {
  content: attr(data-number);
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-size: 2rem;
  font-weight: bold;
  pointer-events: none;
}

// Others

.column.is-one-third,
.column.is-two-fifths {
  margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/Benchmark.vue